export interface LandingEventKeys {
  /** `service_entry_pv` event_key */
  pv: string;
  /** `service_conversion_sub` event_key for the promo banner CTA */
  promoCta: string;
  /** `service_conversion_sub` event_key for the sticky CTA */
  stickyCta: string;
}

/**
 * Derives every Amplitude event_key for a landing page from its slug's
 * **second** segment, e.g. `investors/national-growth-fund` →
 * `national_growth_fund_*`.
 *
 * Returns `undefined` for a slug with fewer than two segments — such a page
 * tracks nothing at all, which is why single-segment slugs are forbidden.
 * This rule is load-bearing for reporting: keep it in this one place.
 */
export function deriveEventKeys(
  slugPath: string | undefined
): LandingEventKeys | undefined {
  if (!slugPath) return undefined;
  const segments = slugPath.split('/').filter(Boolean);
  if (segments.length < 2) return undefined;
  const secondary = segments[1].replace(/-/g, '_');
  return {
    pv: `${secondary}_content_landing_page_pv`,
    promoCta: `${secondary}_promo_small_cta_click`,
    stickyCta: `${secondary}_sticky_cta_click`,
  };
}
